<template>
  <div class="height-100 feedbackTabsBox">
     <van-overlay :show="overlayShow" @click="show = false" z-index="9999"/>
    <div class="bg-FF fixed width-100 z-99">
      <van-tabs v-model="activeIndex"  @click="selectTab">
        <van-tab v-for="(item, index) in tabs" :key="index" :title="item.title"></van-tab>
      </van-tabs>
    <div class="searchBox p-24">
     <div class="rela m-r-24" style="width: calc(100%  - 60px);">
        <van-icon style="position: absolute ;left:12px; top:calc(50% - 11px);z-index: 999;" name="search" class="cor-99"  @click="openDeptUserTree" size="22" />
        <van-field v-model="queryParams.name" placeholder="搜索条件" label="" @click="openDeptUserTree" readonly class="p-t-0 p-l-68 p-b-0 b-r-40 width-100 h-70 inputPull cor-99"  />
        <van-icon v-if="queryParams.name" name="close"  style="position: absolute ;right:12px; top:calc(50% - 10px); z-index:9999" class="cor-99"  size="20"  @click="onClear()" />
    </div>
    <div class="w-110 h-66 l-h-66 bg-FFDA3E b-r-40 text-center font-28"  @click="onSearch">搜索</div>
      <!-- <van-search class="" v-model="queryParams.name" placeholder="搜索条件"  clearable  shape="round" @search="onSearch" show-action>
        <template #action>
          <div class="w-110 h-66 l-h-66 bg-FFDA3E b-r-40 text-center"  @click="onSearch">搜索</div>
        </template>
      </van-search> -->
    </div>
       <div class="flex dateTimeBox  row-between col-center p-l-16 p-r-16 p-t-24 p-b-24 font-28 cor-66">
        <div @click="isShowTimePopup()">
          筛选时间
          <van-icon class="m-l-6" name="play" style="transform: rotate(90deg);" />
        </div>
        <div>{{sxsjLabel}}</div>
        <template>
          <van-popup v-model="sxsj.show" position="bottom" class="dateTimeBoxPopup">
            <van-tabs v-model="sxsj.active">
              <van-tab title="开始时间">
                 <van-datetime-picker
                    v-model="startTime"
                    type="date"
                    title="选择年月"
                  
                />
              </van-tab>
              <van-tab title="结束时间">
                <van-datetime-picker
                    v-model="endTime"
                      type="date"
                    title="选择日期"
                />
              </van-tab>
            </van-tabs>

            <div class="m-t-70 m-b-50 text-center">
              <van-button type="default" class="m-20 b-r-8" @click="sxsj.show = false">取 消</van-button>
              <van-button type="primary" class="m-20 b-r-8" @click="sxsjConfirm">确 定</van-button>
            </div>
          </van-popup>
        </template>
      </div>
      <!--员工树结构-->
       <DeptUserTreeNew ref="deptUserTreeRef" @clearDept="clearDept" @deptUserTreeSubmit="deptUserTreeSubmit"  :deptBool="true" :show-checkbox="false" />
   
    </div>
    <!--内容区域-->
    <div class="p-l-20 p-r-20 p-b-20 p-t-280  tabContentBox">
      <div v-if="(activeIndex==0&&receivedInfoList.length==0)||(activeIndex==1&&noInfoList.length==0)" class="width-100  min-h-vh-80 noDataBox flex row-center col-center">
        <img src="@/assets/icon/feedbackStatistics/noData.png" alt="没有数据" class="width-50 m-l-40">
        <p class="cor-66 m-t-24 font-28">暂无数据</p>
      </div>
      <div v-else class="slide-transition">
        <!-- <van-pull-refresh v-model="refreshing" @refresh="onRefresh" > -->
          <van-list
            v-model="loading"
            :immediate-check="false"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
          >
            <!-- 已反馈 -->
            <feedbackReceived 
              v-if="activeIndex === 0" 
              :feedbackReceivedData="receivedInfoList" 
            />
            <!-- 工作效能 -->
            <noFeedback 
              v-if="activeIndex === 1" 
              :feedbackNoInfoList="noInfoList" 
            />
          </van-list>
        <!-- </van-pull-refresh> -->
      </div>
    </div>
  </div>
</template>

<script>
import mixin from '@/mixin/flow'
import moment from "moment";
import {methodGetApi} from "@/api/publicApi";
import cache from "@/plugins/cache";
import DeptUserTreeNew from "@/components/deptUserTree/indexNew.vue";
import feedbackReceived from '@/views/feedbackStatistics/components/feedbackReceived.vue'
import noFeedback from '@/views/feedbackStatistics/components/noFeedback.vue'
export default {
  
  name: 'employeeKanbanIndex',
  provide() {
    return {
      feedbackStatisticsProvide: this
    }
  },
  mixins: [mixin],
  components: {
    DeptUserTreeNew,
    feedbackReceived,
    noFeedback
  },

  data() {
    return {
      overlayShow:false,
      clearShow:false,
      baseUrl: process.env.VUE_APP_BASE_URL,
      moment,
      userInfo: {},
      activeIndex: 0,
      tabs: [
        {title: '已反馈详情', apiUrl: '/ep/coreInfo', checkInApi: '/work/total/checkIn'},
        {title: '未反馈汇总', apiUrl: '/ep/workInfo'},
      ],
      // 已反馈相关
      receivedInfoList: [],
      receivedListTotal: 0,
      // 未反馈相关
      noInfoList: [],
      noListTotal: 0,
      
      loading: false,
      finished: false,
      refreshing: false,
      startTime: new Date(moment(new Date()).subtract(1, 'days').format('YYYY-MM-DD')),
      endTime: new Date(moment(new Date()).subtract(1, 'days').format('YYYY-MM-DD')),
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        startTime: moment(new Date()).subtract(1, 'days').format('YYYY-MM-DD'),
        endTime:moment(new Date()).subtract(1, 'days').format('YYYY-MM-DD')
      },
      sxsjLabel: `${moment(new Date()).subtract(1, 'days').format('YYYY-MM-DD')}  -  ${moment(new Date()).subtract(1, 'days').format('YYYY-MM-DD')}`,
      sxsj: {
        show: false
      },
      sliderStyle: {
        transform: 'translateX(0)',
        transition: 'transform 0.3s ease'
      },
      currentTranslateX: 0,
      isDragging: false,
      startX: 0,
      currentIndex: 0,
      totalRecords: 0, // 总记录数
      allProjects: [], // 存储所有项目数据，用于合并
      isPageReload: false, // 添加标识是否为页面刷新
    }
  },
  created() {
    // 检测是否为刷新
    const isPageRefresh = sessionStorage.getItem('pageRefreshed') === 'true';
    const currentPath = this.$route.path;
    const previousPath = sessionStorage.getItem('previousPath');
    // 如果是刷新且在同一页面
    const isSamePageRefresh = isPageRefresh && previousPath === currentPath;
    let query = this.$route.query;
    // 如果是同页面刷新且有查询参数，则清除
    if (isSamePageRefresh && Object.keys(query).length > 0) {
      this.clearRouteQuery();
    }else{
      this.initQuery(query);
    }
    // 更新 sessionStorage 状态
    sessionStorage.setItem('previousPath', currentPath);
    sessionStorage.setItem('pageRefreshed', 'false');
  },
  mounted() {
    // 页面加载完成后标记为已加载
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem('pageRefreshed', 'true');
    });
  },
  methods: {
  // 清除路由查询参数的独立方法
  clearRouteQuery() {
    this.$router.replace({ query: {} }).catch(err => {
      console.log('路由替换出错:', err);
    });
    this.queryParams={
        pageNum: 1,
        pageSize: 10,
        startTime: moment(new Date()).subtract(1, 'days').format('YYYY-MM-DD'),
        endTime: moment(new Date()).subtract(1, 'days').format('YYYY-MM-DD'),
    }
    // 同步更新 datetime-picker 绑定的变量
    this.startTime = new Date(moment(new Date()).subtract(1, 'days').format('YYYY-MM-DD'));
    this.endTime = new Date(moment(new Date()).subtract(1, 'days').format('YYYY-MM-DD'));
    this.selectTab(0);
  },

   // 跳转页面返回时的查询条件重置
    initQuery(query) {
      console.log(query);
      if(query.startTime && query.endTime) {
        this.queryParams.startTime = query.startTime;
        this.queryParams.endTime = query.endTime;
        this.sxsjLabel = `${query.startTime}  -  ${query.endTime}`;
          // 同步更新 datetime-picker 绑定的变量
      this.startTime = new Date(query.startTime);
      this.endTime = new Date(query.endTime);
      }
      if(query.name) {
        this.queryParams.name = query.name;
      }
      if(query.pageNum) {
        this.queryParams.pageNum = query.pageNum;
        this.queryParams.pageSize = query.pageSize;
      }
      if(query.deptId) {
        this.queryParams.deptId = query.deptId;
      }
      if(query.userId) {
        this.queryParams.nickName = query.nickName;
        this.queryParams.userId = query.userId;
      }
      console.log(this.queryParams);
      this.selectTab(0);
  },
  isShowTimePopup() {
    this.sxsj.active = 0;
    this.sxsj.show = true;
    this.$nextTick(() => {
      console.log(this.queryParams);
      // 将 queryParams 中的日期值赋给 datetime-picker 绑定的变量
      if (typeof this.queryParams.startTime === 'string') {
        this.startTime = new Date(this.queryParams.startTime);
      } else {
        this.startTime = this.queryParams.startTime ? new Date(this.queryParams.startTime) : new Date();
      }
      console.log(this.startTime);  
      if (typeof this.queryParams.endTime === 'string') {
        this.endTime = new Date(this.queryParams.endTime);
      } else {
        this.endTime = this.queryParams.endTime ? new Date(this.queryParams.endTime) : new Date();
      }
    });
},
    sxsjConfirm() {
      // 将 date 对象转换为字符串格式
      const startFormatted = moment(this.startTime).format('YYYY-MM-DD');
      const endFormatted = moment(this.endTime).format('YYYY-MM-DD');
      
      // 验证时间范围
      if (moment(endFormatted).isBefore(startFormatted)) {
        this.$toast('开始时间不能大于结束时间');
        return;
      }
      
      // 更新查询参数
      this.queryParams.startTime = startFormatted;
      this.queryParams.endTime = endFormatted;
      
      // 更新显示标签
      this.sxsjLabel = `${startFormatted} - ${endFormatted}`;
      
      // 关闭弹窗
      this.sxsj.show = false;
      
      // 重置分页并加载数据
      this.resetPagination();
      this.loadTabData(this.activeIndex);
    },
    openDeptUserTree() {
      this.$refs.deptUserTreeRef.deptUserTreeAll.show = true
      this.$refs.deptUserTreeRef.deptUserTreeAll.filterText =this.queryParams.name
    },
    deptUserTreeSubmit(data) {
      this.resetPagination()
      this.overlayShow=true
      this.refreshing = false;
      this.queryParams.name=data.name;
      if(data.type=='dept'){
          this.queryParams.nickName = '';
        this.queryParams.userId ='';
        this.queryParams.deptId = data.id;
      }else{
        this.queryParams.nickName = data.name;
        this.queryParams.userId = data.id;
        this.queryParams.deptId = data.parentId;
      }
    
      this.onSearch()
    },
    clearDept(){
      this.onClear('clearDept')

    },
    selectTab(index, title) {
      this.activeIndex = index;
      this.resetPagination()
      this.overlayShow=true
      this.refreshing = false;
      this.loadTabData(index);
     
    },
    onSearch() {
      if (Object.keys(this.$route.query).length > 0) {
        this.$router.replace({ query: {} }).catch(err => {
          console.log('路由替换出错:', err);
        });
      }
      this.selectTab(this.activeIndex)
    },
    onClear(type){
      this.$nextTick(() => {
        let data={
            pageNum: 1,
            pageSize: 10,
            startTime:this.queryParams.startTime,
            endTime: this.queryParams.endTime,
        }
        this.$set( this,'queryParams',data)
        if(type!='clearDept'){
          this.onSearch()
        }
        this.$refs['deptUserTreeRef'].treeData={}
      });
    },
    // 重置分页参数
    resetPagination() {
      this.queryParams.pageNum = 1
      this.queryParams.pageSize = 10
      this.loading = false
      this.finished = false
      this.totalRecords=0
      this.allProjects=[]
      this.receivedInfoList = []
      this.noInfoList = []
     
    },
    
    async loadTabData(index) {
      this.activeIndex = index
      this.resetPagination()
      if (index == 0) {
        await this.getFeedbackReceivedList()
      } else {
        await this.getNoFeedbackList()
      }
    },
    
    //已反馈数据列表
    getFeedbackReceivedList() {
      let url = '/project/statistics/feedbackStatistics'
      methodGetApi(url, this.queryParams).then(res => {
        console.log('已反馈数据-----------------------1', res)
        this.totalRecords=res.total||0
        this.allProjects.push(...res.rows)
        this.receivedInfoList = this.allProjects
        if (this.allProjects.length >= this.totalRecords) {
          this.finished = true;
        }
        this.overlayShow=false
        // 加载状态结束
        this.loading = false;
      })
    },
    
    //未反馈数据列表
    getNoFeedbackList() {
      let url = '/project/statistics/notFeedbackStatisticsYD'
      methodGetApi(url, this.queryParams).then(res => {
        // console.log('未反馈数据-----------------------1', res)
        this.totalRecords=res.total||0
        this.allProjects.push(...res.rows)
        this.noInfoList = this.allProjects
        if (this.allProjects.length >= this.totalRecords) {
                this.finished = true;
        }
        this.overlayShow=false
        // 加载状态结束
        this.loading = false;
      })
    },
    
    // 上拉加载
    async onLoad() {
      console.log('onLoad触发')
      console.log(this.queryParams.pageNum)
      // try {
      //   // 根据当前标签加载对应数据
  
        if (this.activeIndex === 0) {
          // 已反馈详情 - 按要求更新分页参数
          if (this.totalRecords ==this.allProjects.length || this.totalRecords ==0) {
             this.finished = true;
          }
          this.queryParams.pageNum++
          
          await this.getFeedbackReceivedList()
        } else {
          // 未反馈汇总 - 按要求更新分页参数
          this.queryParams.pageNum++
          await this.getNoFeedbackList()
        }
      // } catch (error) {
      //   console.error('加载数据失败:', error)
      //   this.$toast('加载数据失败')
      //   // 加载失败时，需要回退页码
      //   this.queryParams.pageNum--
      // } finally {
      //   // 加载完成，将 loading 设置为 false
      //   this.loading = false
      // }
       
    },
    
    // 下拉刷新
    async onRefresh() {

      // console.log('下拉刷新触发')
          // 清空列表数据
      this.finished = false;
      // 重新加载数据
        if(this.queryParams.pageNum==1){
        this.allProjects=[]
      }
      // 将 loading 设置为 true，表示处于加载状态
      
      this.loading = true;
      this.onLoad();
      // // 重置分页参数
      // this.queryParams.pageNum = 1
      // this.queryParams.pageSize = 10
      // this.finished = false
      
      // try {
      //   if (this.activeIndex === 0) {
      //     await this.getFeedbackReceivedList()
      //   } else {
      //     await this.getNoFeedbackList()
      //   }
      // } catch (error) {
      //   console.error('刷新数据失败:', error)
      //   this.$toast('刷新数据失败')
      // } finally {
      //   this.refreshing = false
      // }
    },
  }
}
</script>
<style lang="less" >

.feedbackTabsBox {
  .dateTimeBoxPopup{
    .van-picker__toolbar{
      display: none;
    }
  }
  .searchBox{
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: center;
  }
  .noDataBox{
    height: calc(100% - 120px);
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .dateTimeBox{
    background:  @base-background-color;
  }
  .tabContentBox{
      min-height: calc(100% - 60px);
      // overflow-y: auto;
  }
  .inputPull{
    background: #f7f8fa;
    .van-field__body{
      height: 100%;
    }
  }
}
</style>